import React, {useEffect, useState} from "react";
import CameraComponent from "../../components/common/camera/CameraComponent";
import {useParams} from "react-router-dom";
import {RouteParam} from "../../types/types";
import {VerifyService} from "../../service/VerifyService";
import {MaskType} from "../../components/common/camera/MaskType";
import ProcessingComponent from "../../components/common/processing/ProcessingComponent";
import {useStepCheck} from "../../hooks/stepcheck/useStepCheck";
import {FacingModeType} from "../../components/common/camera/FacingModeType";
import {useSubmit} from "../../hooks/submit/useSubmit";

const CaptureDocumentBackPage: React.FC = () => {

    const { verificationId } = useParams<RouteParam>();

    const { evaluateUrl } = useStepCheck(verificationId)
    const { submitImage } = useSubmit(verificationId)
    const [loading, setLoading] = useState(false)
    const [success, setSuccess] = useState(false)

    useEffect(() => {
        evaluateUrl()
    }, [evaluateUrl])

    const onPhotoTaken = () => {
        setLoading(true)
    }

    const onSubmit = async (image: Blob) => {
        await submitImage(image, submitAction, () => setLoading(false))
    }

    const submitAction = async (document: Blob) => {
        if (verificationId) {
            setLoading(true)
            await VerifyService.getInstance().sendDocumentBack(document, verificationId)
            setSuccess(true)
            setTimeout(async () => {
                await evaluateUrl()
                setSuccess(false)
                setLoading(false)
            }, 1000)
        }
    }

    const tooltip = (
        <>
            <span>Fit the back of your document inside the frame</span>
            <br/>
            <span>and make sure it’s in focus</span>
        </>
    )

    return loading ?
        <ProcessingComponent loadingAnimation="processingId" successAnimation="processComplete" success={success}/>
        : <CameraComponent
                onSubmit={(blob: Blob) => onSubmit(blob)}
                onPhotoTaken={() => onPhotoTaken()}
                maskType={MaskType.DOCUMENT}
                facingMode={FacingModeType.ENVIRONMENT}
                tooltip={tooltip}
                identifierText="Back"
                isDocument
                back
                withRetake
            />

}

export default CaptureDocumentBackPage